import React, {Component, useState} from "react";
import {Link} from 'react-router-dom'
import {Icon, Dropdown, Menu} from 'semantic-ui-react'
import {useNavigate} from "react-router";


export default function Navigation(props) {
    const [data, setData] = useState({activeItem: 'home', loading: true});


    const handleItemClick = (e, {name}) => setData({activeItem: name})

    const navigate = useNavigate()

    const logout = (e) => {
        sessionStorage.removeItem('token')
        setData({})
        navigate("/login")
    }

    const {activeItem} = data

    const token = sessionStorage.token
    if (!(token && token.length > 0)) {
        return <Menu fixed="top" inverted>
            <Menu.Item
                as={Link}
                name='home'
                to="/login"
                active={activeItem === 'home'}
                onClick={handleItemClick}>
                POJEX
            </Menu.Item>
        </Menu>
    } else {
        return (
            <div>
                <Menu fixed="top" inverted>
                    <Menu.Item
                        as={Link}
                        name='home'
                        to="/"
                        active={activeItem === 'home'}
                        onClick={handleItemClick}
                    >POJEX</Menu.Item>
                    <Menu.Item
                        as={Link}
                        name='contacts'
                        active={activeItem === 'contacts'}
                        to="/contacts"
                        onClick={handleItemClick}
                    >
                        Contacts
                    </Menu.Item>
                    <Menu.Item
                        as={Link}
                        name='items'
                        active={activeItem === 'items'}
                        to="/items"
                        onClick={handleItemClick}
                    >
                        Items
                    </Menu.Item>
                    <Menu.Item
                        as={Link}
                        name='invoices'
                        active={activeItem === 'invoices'}
                        to="/invoices"
                        onClick={handleItemClick}
                    >
                        Invoices
                    </Menu.Item>
                    <Menu.Item
                        as={Link}
                        name='credit-notes'
                        active={activeItem === 'credit-notes'}
                        to="/credit-notes"
                        onClick={handleItemClick}
                    >
                        Credit Notes
                    </Menu.Item>
                    <Menu.Item
                        as={Link}
                        name='operating-costs'
                        active={activeItem === 'operating-costs'}
                        to="/operating-costs"
                        onClick={handleItemClick}
                    >
                        Operating Costs
                    </Menu.Item>
                    <Dropdown item simple text='Balances'>
                        <Dropdown.Menu>
                            <Dropdown.Item
                                as={Link}
                                name='balance/2024'
                                active={activeItem === 'balance/2024'}
                                to="/balance/2024"
                                onClick={handleItemClick}
                            >
                                Balance 2024
                            </Dropdown.Item>
                            <Dropdown.Item
                                as={Link}
                                name='balance/2023'
                                active={activeItem === 'balance/2023'}
                                to="/balance/2023"
                                onClick={handleItemClick}
                            >
                                Balance 2023
                            </Dropdown.Item>
                            <Dropdown.Item
                                as={Link}
                                name='balance/2022'
                                active={activeItem === 'balance/2022'}
                                to="/balance/2022"
                                onClick={handleItemClick}
                            >
                                Balance 2022
                            </Dropdown.Item>
                            <Dropdown.Item
                                as={Link}
                                name='balance/2021'
                                active={activeItem === 'balance/2021'}
                                to="/balance/2021"
                                onClick={handleItemClick}
                            >
                                Balance 2021
                            </Dropdown.Item>
                            <Dropdown.Item
                                as={Link}
                                name='balance/2020'
                                active={activeItem === 'balance/2020'}
                                to="/balance/2020"
                                onClick={handleItemClick}
                            >
                                Balance 2020
                            </Dropdown.Item>
                            <Dropdown.Item
                                as={Link}
                                name='balance/2019'
                                active={activeItem === 'balance/2019'}
                                to="/balance/2019"
                                onClick={handleItemClick}
                            >
                                Balance 2019
                            </Dropdown.Item>
                            <Dropdown.Item
                                as={Link}
                                name='balance/2018'
                                active={activeItem === 'balance/2018'}
                                to="/balance/2018"
                                onClick={handleItemClick}
                            >
                                Balance 2018
                            </Dropdown.Item>
                            <Dropdown.Item
                                as={Link}
                                name='balance/2017'
                                active={activeItem === 'balance/2017'}
                                to="/balance/2017"
                                onClick={handleItemClick}
                            >
                                Balance 2017
                            </Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown>
                    <Dropdown item simple text='Zoho Grabber'>
                        <Dropdown.Menu>
                            <Dropdown.Item
                                as={Link}
                                name="zoho-grabber-contact"
                                active={activeItem === 'zoho-grabber-contact'}
                                to="/zoho-grabber/contact"
                                onClick={handleItemClick}
                            >
                                Contact
                            </Dropdown.Item>
                            <Dropdown.Item
                                as={Link}
                                name="zoho-grabber-item"
                                active={activeItem === 'zoho-grabber-item'}
                                to="/zoho-grabber/item"
                                onClick={handleItemClick}
                            >
                                Item
                            </Dropdown.Item>
                            <Dropdown.Item
                                as={Link}
                                name="zoho-grabber-invoice"
                                active={activeItem === 'zoho-grabber-invoice'}
                                to="/zoho-grabber/invoice"
                                onClick={handleItemClick}
                            >
                                Invoice
                            </Dropdown.Item>
                            <Dropdown.Item
                                as={Link}
                                name="zoho-grabber-credit-note"
                                active={activeItem === 'zoho-grabber-credit-note'}
                                to="/zoho-grabber/credit-note"
                                onClick={handleItemClick}
                            >
                                Credit Note
                            </Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown>
                    <Dropdown item simple text='Export'>
                        <Dropdown.Menu>
                            <Dropdown.Item
                                as={Link}
                                name="export-steuerberater"
                                active={activeItem === 'export-steuerberater'}
                                to="/export/steuerberater"
                                onClick={handleItemClick}
                            >
                                Steuerberater
                            </Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown>
                    <Menu.Item
                        onClick={logout}>
                        <Icon name="sign out"/>Abmelden
                    </Menu.Item>
                </Menu>
            </div>
        )
    }
}

